import { encode as cborEncode, decode as cborDecode } from "cbor-x";

export function encode(value: unknown): Uint8Array {
  return cborEncode(value);
}

export function decode<T = unknown>(data: Uint8Array | ArrayBuffer): T {
  const buf = data instanceof ArrayBuffer ? new Uint8Array(data) : data;
  return cborDecode(buf) as T;
}
